<template>
  <div :class="'w-full overflow-hidden group ' + css" v-if="image">
    <img
      class="w-full h-full object-cover cursor-pointer transform transition-transform duration-150 group-hover:scale-105"
      :src="image"
      alt="Newsbild"
      @click="emitInput"
    />
  </div>
</template>

<script>
import { Image } from "@/modules/images/viewmodels/Image";

export default {
  name: "SingleImage",
  data() {
    return {};
  },
  props: {
    image: {
      type: String,
    },
    css: {
      type: String,
      default: "h-72",
    },
  },
  components: {},
  methods: {
    emitInput() {
      this.$emit("input");
    },
  },
  computed: {},
  async created() {},
};
</script>
